module.exports = __webpack_public_path__ + "img/avatar-4.4036aa1f.jpg";